import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backDrop: {
      backdropFilter: 'blur(8px)',
      backgroundColor: 'rgba(0,0,30,0.4)',
      padding: 75,
    },
    logoContainer: {
      cursor: 'pointer',
      maxWidth: 200,
      margin: 'auto',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 160,
        margin: 'auto',
      },
    },
    logo: {
      width: '100%',
      height: 'auto',
    },
    logoImg: {
      width: '100%',
      height: 'auto',
    },
    dialogTitle: {
      color: '#23296F',
      textAlign: 'center',
      fontSize: '1rem',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 500,
      marginTop: 25,
    },
    formContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      '@media (min-width: 1250px)': {
        maxWidth: 410,
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '90%',
    },
    fieldWithLabel: {
      marginTop: 20,
      width: '100%',
    },
    errorField: {
      color: theme.palette.warning.main,
      font: 'normal normal bold 10px/14px ITC Avant Garde Gothic Std Medium',
    },
    input: {
      flex: 1,
      border: `1px solid #E3E8F0`,
      width: '100%',
      marginTop: 5,
      height: 48,
      '&:before': {
        display: 'none',
      },
      '& input': {
        fontSize: 13,
        padding: 10,
      },
    },
    inputPassword: {
      paddingRight: 5,
    },
    labelText: {
      margin: 'auto',
      color: '#0E1247',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 16,
    },
    btnConnectContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: 20,
      width: '100%',
    },
    btnConnect: {
      width: '90%',
      backgroundColor: '#000A8C',
      borderRadius: 3,
      opacity: 1,
      textTransform: 'none',
      color: '#fff',
      alignSelf: 'center',
      paddingTop: 25,
      paddingBottom: 25,
      '& .MuiButton-label': {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
      },
      '&:hover': {
        color: '#000A8C;',
        border: '1px solid #000A8C',
      },
    },
    forgotPasswordLink: {
      marginTop: 5,
      textAlign: 'end',
    },
    forgotPasswordLinkText: {
      color: '#000A8C',
      textDecoration: 'underline',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      marginTop: 3,
      marginBottom: 5,
      '@media (max-width: 600px)': {
        fontSize: 12,
      },
    },
    signupLink: {
      marginTop: 20,
      cursor: 'pointer',
    },
    signupLinkText: {
      color: '#000A8C',
      textDecoration: 'underline',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      marginTop: 9,
      marginBottom: 5,
      '@media (max-width: 600px)': {
        fontSize: 12,
      },
    },
    passwordErrorField: {
      color: theme.palette.warning.main,
      font: 'normal normal bold 10px/14px ITC Avant Garde Gothic Std Medium',
      minHeight: 20,
      maxWidth: 330,
    },
    eyeImg: {
      cursor: 'pointer',
      zIndex: 1,
    },
    inputWitAdornment: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    selectLanguageButton: {
      border: '1px solid rgb(202, 202, 202)',
      borderRadius: 4,
    },
  })
);

export default useStyles;
